<template>
  <div class="expoup__wrapper">
    <main-header
      :main-title="mainTitle"
      :sub-title="subTitle"
      :isOpen="showAside"
      :settings-open="showSettings"
      @aside-click="showingAside"
      @close-settings="showSettings = false"
    />
    <div class="progress-bar__wrapper">
      <progress-bar />
    </div>
    <div
      id="content__wrapper"
      class="content__wrapper"
    >
      <pre-loader v-if="loading"/>
      <router-view
        v-if="isDashboard"
        :locale="locale"
        :updatePwaExist="updatePWAExist"
        :points-list="asidePointList"
        @switch-locale="switchLocale"
        @open-settings="showSettings = true"
        @update-pwa="updatePWA(true)"
      />
      <router-view
        v-else-if="isRouterView"
        :locale="locale"
        :launch-download="trunkOnDownload"
        :updatePwaExist="updatePWAExist"
        @update-config="updateConfig"
        @update-pwa="updatePWA(true)"
        @turn-off="eventTrunkDownload"
        @loading="showingPreloader"
        @show-banner="showingBanner"
        @switch-locale="switchLocale"
      />
    </div>
    <system-notification
      :push-ask-exist="showPushAsk"
      @close-push-ask="showPushAsk = false"
    />
    <toast-list />
    <bottom-nav
      v-if="showBottomNav"
      :fast-points-list="bottomNavPoints"
    />
    <aside-menu
      v-if="showAside"
      :locale="locale"
      :updatePwaExist="updatePWAExist"
      :points-list="asidePointList"
      @switch-locale="switchLocale"
      @open-settings="showSettings = true"
      @update-pwa="updatePWA(true)"
    />
    <settings-aside
      v-if="showSettings"
      :locale="locale"
      @switch-locale="applyLocale"
      @logout="handleLogout"
      @close="showSettings = false"
    />
    <div
      v-if="launchScreen"
      class="launch-screen"
    >
      <img
        src="/img/entrance-2.jpg"
        alt=""
      />
    </div>
    <ad-banner
      v-if="adBannerShowing"
      :banner="adBanner"
      @update-banner="adBannerShowing = false"
    />
  </div>
</template>

<script>
// import { DateTime } from 'luxon';
import global from '@/components/mixins/methodsGlobal';
import userMethods from '@/components/mixins/methodsUser';
import methodsEventsList from '@/components/mixins/methodsEventsList';
import updatePwa from '@/components/mixins/methodsPwaUpdate';
import timeCombaine from '@/components/mixins/timeCombaine';
import asideMenu from '@/components/shared/asideMenu/indexAsideMenu.vue';
import settingsAside from '@/components/shared/asideMenu/settingsAside.vue';
import adBanner from '@/components/shared/adBannerView.vue';
import progressBar from '@/components/shared/progressBar.vue';
import systemNotification from '@/components/shared/systemNotification/index.vue';
import toastList from '@/components/shared/systemNotification/toastList.vue';
import methodsScanner from '@/components/mixins/api/apiMethodsScanner';
import push from '@/components/mixins/methodsPush';
import methodsLogin from '@/components/mixins/methodsLogin';
import { writeFavoriteCalendar } from '@/components/mixins/api/apiMethodsProgramFavorite';
import { pickBottomNavPoints, toMenuPoint } from '@/components/mixins/menuPoints';
import { checkForUpdateQuietly } from '@/components/mixins/appMaintenance';
// import bottomPwaUpdate from '@/components/shared/updPWA.vue';

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {
    progressBar, asideMenu, settingsAside, adBanner, systemNotification, toastList,
  },
  data() {
    return {
      expoData: {},

      showedLauncScreen: false,
      timeoutLS: null,

      // showBanner: false,
      timerBanner: 0,
      timeoutShowBanner: null,
      timeoutCheckBanner: null,

      adBanner: {},
      adBannerShowing: false,

      showAside: false,
      showSettings: false,
      showPushAsk: false,
      mainContent: null,
      appLoaded: false,
      trunkOnDownload: false,
      loadingInbox: false,
      loading: false,
    };
  },
  mixins: [
    global, userMethods, methodsEventsList, methodsScanner,
    updatePwa, timeCombaine, push, methodsLogin,
  ],
  created() {
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    },
    // Экран ссылки нужен и там, где мероприятие ещё не выбрано: он его и выбирает.
    isRouterView() {
      return this.appLoaded && (this.$store.getters.getExhId
        || this.$route.name === 'EventsListView' || this.$route.name === 'deepLink');
    },
    isDashboard() {
      return this.$route.name === 'DashboardView';
    },
    asidePointList() {
      return this.expoData.apps || [];
    },
    bottomNavPoints() {
      const points = pickBottomNavPoints(this.expoData.fastApps, this.expoData.apps, this.$router);
      return points && points.map((item) => toMenuPoint(item, this.locale));
    },
    showBottomNav() {
      // Пустой состав от сервера — панель на этом мероприятии не нужна
      const hasPoints = !this.bottomNavPoints || this.bottomNavPoints.length > 0;
      return this.$store.getters.isVisiblBottomNav && hasPoints;
    },
    mainTitle() {
      if (this.showSettings) return this.$t('settings.title');

      return (this.showAside || !this.$store.getters.getPageTitle)
        ? this.$store.getters.getMainTitle : this.$store.getters.getPageTitle;
    },
    dateSubtitle() {
      return this.testDateSubtitle(this.expoData.start_ts, this.expoData.end_ts);
    },
    subTitle() {
      if (this.showSettings) return '';

      return (this.showAside || this.isDashboard) && this.expoData.start_ts && this.expoData.end_ts ? this.dateSubtitle : '';
    },
    contentOffsetHeight() {
      return this.mainContent.offsetHeight;
    },
    launchScreen() {
      if (!this.showedLauncScreen) {
        return this.expoData.launchScreen || null;
      }
      return null;
    },
    locale: {
      get() {
        return this.$i18n.locale;
      },
      set(locale) {
        localStorage.setItem('__exup__locale', locale);
        this.$i18n.locale = locale;
      },
    },
    showBanner: {
      get() {
        return this.expoData.bannerSrc || null;
      },
      set(src) {
        this.expoData.bannerSrc = src;
      },
    },
    languageList() {
      return this.$store.getters.getLanguageList;
    },
  },
  watch: {
    // Язык, которого у мероприятия нет, оставлять нельзя: переключателя, чтобы
    // с него уйти, в настройках уже не будет. Уводим на первый из справочника.
    languageList(list) {
      const languages = Object.keys(list);

      if (languages.length && !languages.includes(this.locale)) {
        this.applyLocale(languages[0]);
      }
    },
    $route() {
      this.showAside = false;
      this.showSettings = false;
    },
    // Токен появился — либо человек только что вошёл, либо приложение запустилось
    // с сохранённым входом. Спрашивать уместно в обоих случаях: сам показ
    // ограничен тремя часами и отказом, а иначе про уведомления просто забудут.
    token(value) {
      if (value) this.maybeAskPush();
    },
  },
  beforeMount() {
    this.screenResize();
    window.addEventListener('resize', this.screenResize);

    this.checkToken();
    this.declinedUpdTs = localStorage.getItem('__cancel_update__');

    if (!this.showedLauncScreen) {
      this.timeoutLS = setTimeout(() => {
        this.showedLauncScreen = true;
      }, 2000);
    }

    // Сначала роутер: решение ниже зависит от маршрута, а первый переход
    // асинхронный, и экраны ссылки и быстрого входа ленивые. Не удался
    // переход (не загрузился чанк) — уходим на home, иначе appLoaded так и
    // останется false и контента не будет вовсе.
    this.$router.isReady()
      .catch(() => this.$router.replace({ name: 'home' }))
      .then(() => {
        // Мероприятие задаёт ссылка, а проверяет её экран — он же и запросит
        // список. Конфиг здесь не грузим: ответ по прежнему мероприятию может
        // прийти позже нового и затереть его — updateConfig устаревшие ответы
        // не отбрасывает.
        if (this.$route.name === 'deepLink') {
          this.appLoaded = true;
          return null;
        }
        return this.getEventsList().then((data) => this.checkSelectedEvent(data));
      });
  },
  mounted() {
    this.mainContent = document.getElementById('content__wrapper');
    this.mainContent.addEventListener('scroll', this.handleScrollToBottom);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', this.onServiceWorkerMessage);
    }

    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    // Установленное приложение возвращается из фона, а не перезапускается, и
    // браузер при этом новую версию не ищет. Ищем сами; найденную покажет
    // обычное предложение обновиться. Здесь, а не в methodsPwaUpdate: миксин
    // подключён ещё и к systemNotification, проверка шла бы дважды.
    onVisibilityChange() {
      if (document.visibilityState === 'visible') checkForUpdateQuietly();
    },
    // Выбранное мероприятие должно быть в списке и открыто, иначе выбор
    // сбрасываем и уводим на home.
    checkSelectedEvent(data) {
      let approveID = null;
      if (data) {
        // eslint-disable-next-line max-len
        approveID = data.results.find((eventItem) => eventItem.id === this.$store.getters.getExhId && eventItem.is_public);
      }
      if (approveID) {
        this.updateConfig();
      } else if (this.$route.name === 'authFast') {
        // Мероприятие задаёт сама ссылка быстрой авторизации, а неверный
        // exhId разбирает её экран. Сбрасывать выбор и уводить нельзя —
        // иначе переход по ссылке подменяется списком мероприятий.
        this.appLoaded = true;
      } else {
        this.$store.commit('setExhId', null);
        localStorage.removeItem('exhID');
        this.$router.push({ name: 'home' });
        this.appLoaded = true;
      }
    },
    updateConfig() {
      this.appLoaded = false;

      const exhID = this.$store.getters.getExhId;
      const jsonCachedConfig = localStorage.getItem(`exhID-${exhID}-config`);

      if (jsonCachedConfig) {
        const cachedConfig = JSON.parse(jsonCachedConfig);
        this.applyConfig(cachedConfig);
      } else {
        this.$store.commit('setMainTitle', { lang: 'ru', text: '...' });
        this.$store.commit('setMainTitle', { lang: 'en', text: '...' });
      }

      if (this.$store.getters.getToken && !this.$store.getUserID) {
        this.getUserProfile()
          .then((data) => {
            this.$store.commit('setUserID', data.id || null);
            this.$store.commit('setUserRole', data.role || null);
          });
      }

      // Promise.all([
      //   this.getConfig(exhID),
      //   this.checkInbox(),
      // ])
      Promise.resolve(this.initExhibition(exhID))
        .then(([
          config,
          { notification, chat, mm },
          // inbox,
        ]) => {
          // console.log('3', inbox);
          // const { notification, chat } = inbox;
          this.applyConfig(config);

          if (notification || chat || mm) {
            this.recalcNotification({ notification, chat, mm });
          }

          // Сверка подписки. Браузер меняет подписки молча и предупреждать не
          // обязан, так что без сверки push однажды перестаёт приходить и никто
          // об этом не узнает. Бэк по знакомому endpoint обновит метку, по
          // новому — заведёт запись.
          if (this.$store.getters.getToken) this.syncPushSubscription();

          // Избранное деловой программы сверяем на старте, а не при открытии
          // экрана: так программа и календарь открываются уже с тем составом,
          // который стоит на сервере. Заодно уходит накопленное без сети.
          if (this.$store.getters.getToken) {
            this.syncProgramFavorite()
              .then((cards) => {
                if (cards) writeFavoriteCalendar(exhID, cards);
              })
              .catch((error) => console.error('syncProgramFavorite()::', error));
          }
        })
        .finally(() => {
          this.appLoaded = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // Клик по push, когда приложение уже открыто. Service worker в этом случае
    // не открывает вторую вкладку, а фокусирует эту и присылает сюда payload.
    onServiceWorkerMessage(event) {
      const { type, payload } = event.data || {};

      // Счётчики в уведомлении считаются полными: чего в них нет, того и нет.
      if (type === 'PUSH_RECEIVED') {
        if (payload?.counters) this.recalcNotification(payload.counters);
        return;
      }

      if (type !== 'PUSH_CLICK') return;

      const target = this.pushClickTarget(payload?.url);
      if (target) this.$router.push(target);
    },
    // Уведомление несёт полный адрес — он нужен, чтобы открыть приложение, когда
    // оно закрыто. Здесь же переходим роутером, иначе приложение перезагрузится
    // целиком и потеряет состояние.
    pushClickTarget(rawUrl) {
      if (!rawUrl) return null;

      try {
        const url = new URL(rawUrl, window.location.origin);
        if (url.origin !== window.location.origin) return null;
        return `${url.pathname}${url.search}`;
      } catch (error) {
        return null;
      }
    },
    // перенести в computed
    showingPreloader(state) {
      this.loading = state;
    },
    showingAside() {
      this.showAside = !this.showAside;
      this.checkInbox()
        .then(({ notification, chat, mm }) => {
          if (notification || chat || mm) {
            this.recalcNotification({ notification, chat, mm });
          }
        })
        .catch(() => {});

      this.sendScannerListCode();
    },
    switchLocale(val) {
      this.showAside = false;
      this.applyLocale(val);
      // this.$router.go();
    },
    // Язык из настроек меняется, не трогая меню: панель открыта поверх него, и
    // закрыв её человек должен вернуться туда, откуда пришёл.
    applyLocale(val) {
      this.locale = val;
      this.$store.commit('setLang', val);
    },
    maybeAskPush() {
      if (this.shouldAskPush()) this.showPushAsk = true;
    },
    // После выхода закрываем и панель, и меню: возвращаться человеку уже некуда,
    // половина пунктов под ним теперь для него закрыта.
    handleLogout() {
      return this.logoutUser()
        .then(() => {
          this.showSettings = false;
          this.showAside = false;

          if (this.$route.name !== 'DashboardView') {
            this.$router.push({ name: 'DashboardView' });
          }
        });
    },
    showingBanner({ src, link }) {
      this.adBanner = {
        src,
        link,
        timer: 5,
      };
      this.adBannerShowing = true;
    },
    recalcNotification({ notification = 0, chat = 0, mm = 0 }) {
      this.$store.commit('setNewNotificationCount', notification);
      this.$store.commit('setUnreadChatCount', chat);
      this.$store.commit('setUnApproveMeetingCount', mm);
    },
    eventTrunkDownload({ stateDownload, stateCheckInbox }) {
      if (stateDownload !== undefined) {
        this.trunkOnDownload = stateDownload;
      }
      if (stateCheckInbox !== undefined) {
        this.loadingInbox = stateCheckInbox;
      }
    },
    screenResize() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    handleScrollToBottom() {
      requestAnimationFrame(this.redrawLayer);
    },
    redrawLayer() {
      if (this.mainContent.children.length) {
        const ofsetHeight = this.mainContent.children[0].offsetHeight;
        if (ofsetHeight - this.mainContent.scrollTop < 800) {
          this.trunkOnDownload = true;

          // TODO вынести в отдельный метод проверки состояния
          if (!this.loadingInbox) {
            this.loadingInbox = true;
            this.checkInbox()
              .then(({ notification, chat }) => {
                this.recalcNotification({ notification, chat });
              })
              .catch(() => {
                this.loadingInbox = false;
              });
          }
        }
      } else {
        this.handleScrollToBottom();
      }
    },
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    window.removeEventListener('resize', this.screenResize);
    this.mainContent.removeEventListener('scroll', this.handleScrollToBottom);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener('message', this.onServiceWorkerMessage);
    }

    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
};
</script>

<style lang="scss">
@import url('@/assets/style/fonts.scss');
@import url('@/assets/style/grid-system.scss');
body {
  margin: 0;
  padding: 0;
  background: #303030;
  & * {
    box-sizing: border-box;
  }
}
.expoup__wrapper {
  display: grid;
  width: 100%;
  // max-width: 760px;
  margin: 0 auto;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  grid-template-columns:
    [header-start content-start aside-start bottom-nav-start] 1fr
    [header-end content-end bottom-nav-end aside-end];
  grid-template-rows:
    [header-start] 71px
    [progress-start] 5px
    [header-end progress-end content-start aside-start] 1fr
    [system-start] auto
    [content-end bottom-nav-start] auto [bottom-nav-end aside-end];
  background: #F5F5F3;
  font-size: 16px;
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  color: #2F323A;
}
.progress-bar__wrapper {
  grid-column-start: content-start;
  grid-column-end: content-end;
  grid-row-start: progress-start;
  grid-row-end: progress-end;
  z-index: 800;
}
.content__wrapper {
  grid-column-start: content-start;
  grid-column-end: content-end;
  grid-row-start: content-start;
  // grid-row-end: content-end;
  grid-row-end: bottom-nav-end;
  overflow: hidden auto;
  // z-index: 10;
  padding-bottom: 80px;

  &.full-content {
    grid-column-start: content-start;
    grid-column-end: content-end;
    grid-row-start: aside-start;
    grid-row-end: aside-end;
    z-index: 180;
  }
}
.bottom-update__wrapper, .systemNotification__wrapper {
  grid-column-start: content-start;
  grid-column-end: content-end;
  grid-row-start: system-start;
  grid-row-end: bottom-nav-end;
  z-index: 1000;
}
// Тост живёт строкой выше системного блока и прижат к её низу: над нижней
// панелью, а при показанном окне установки PWA — над ним. Перекрывать навигацию
// ему незачем, в отличие от окон установки и обновления, которые требуют ответа.
.notice__wrapper {
  grid-column-start: content-start;
  grid-column-end: content-end;
  grid-row-start: content-start;
  grid-row-end: system-start;
  align-self: end;
  z-index: 1000;
}
.bottom-nav__wrapper {
  grid-area: bottom-nav;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 160;
  padding: 10px 12px;
  // background: #F5F5F3;
  // background: transparent;
  background: linear-gradient(180deg, rgba(245, 245, 243, 0), rgba(245, 245, 243, 1) 50%);
}

aside {
  grid-area: aside;
  display: flex;
  justify-content: end;
  width: 100%;
  background: rgba(0, 0, 0, .5);
  transition: opacity .5s;
  z-index: 200;
}
.launch-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  grid-column-start: content-start;
  grid-column-end: content-end;
  grid-row-start: header-start;
  grid-row-end: aside-end;
  z-index: 1100;
  // поля под цвет краёв самой картинки: сверху у неё #1C2B40, снизу #0B111F.
  // Две половины, а не градиент: картинка по центру, поэтому верхняя полоса
  // всегда попадает в верхнюю половину, нижняя — в нижнюю, и стык не виден.
  background: linear-gradient(180deg, #1C2B40 0 50%, #0B111F 50% 100%);

  & > img {
    max-width: 100%;
    max-height: 100%;
  }
}
.container-static {
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin: 0 auto;
}
.inner-html {
  & p {
    margin-bottom: 8px;
  }
  & ul {
    padding: 16px;
    margin: 0;
  }
  a {
    color: #2D3038;
    text-decoration: none;
  }
  :last-child {
    margin-bottom: 0;
  }
}
// ===============
.overflow-unset {
  overflow: unset;
}
.html-description-styles {
  li {
    &::marker {
      color: #2D3038;
    }
  }
  .attention {
    li {
      &::marker {
        color: #FCB136;
      }
    }
  }
}
</style>
